module.exports = __webpack_public_path__ + "media/images/endicott-tree-9e4dd00ac4bcea2ee2d7e5d0e854a410.jpg";